import { useSurveyDashboardStore } from '../../store/useSurveyDashboard.store';

export const ToggleFilter = () => {
  const { selectedComponent, updateSelectedComponent, page } = useSurveyDashboardStore((store) => {
    return {
      selectedComponent: store.selectedComponent,
      updateSelectedComponent: store.updateSelectedComponent,
      page: store.page,
    };
  });

  return (
    <div className="flex flex-1 items-center justify-start">
      <label className="inline-flex cursor-pointer items-center p-2">
        <input
          type="radio"
          name="component"
          value={page?.toggle.questions}
          checked={selectedComponent === page?.toggle.questions}
          onChange={(e) => updateSelectedComponent(e.target.value)}
          className="peer sr-only"
        />
        {/* The radio circle; note that this element is immediately after the input */}
        <div className="radio-indicator h-4 w-4 rounded-full border border-[#CFD8DC] peer-checked:border-[#CFD8DC] peer-checked:bg-[#A1C4ED]"></div>
        <span className="ml-1 text-sh-xxs">Questions</span>
      </label>

      <label className="inline-flex cursor-pointer items-center p-2">
        <input
          type="radio"
          name="component"
          value={page?.toggle.categories}
          checked={selectedComponent === page?.toggle.categories}
          onChange={(e) => updateSelectedComponent(e.target.value)}
          className="peer sr-only"
        />
        <div className=" radio-indicator h-4 w-4 rounded-full border border-[#CFD8DC] peer-checked:border-[#CFD8DC] peer-checked:bg-[#A1C4ED]"></div>
        <span className="ml-1 text-sh-xxs">Categories</span>
      </label>
    </div>
  );
};
